<p-table
  styleClass="p-datatable-gridlines"
  [value]="atividadeServicos"
  [scrollable]="true"
  scrollHeight="600px"
  [loading]="loading"
>
  <ng-template pTemplate="header">
    <tr class="font-grid-servicos-header">
      <th>Item</th>
      <th>Local do Serviço</th>
      <th>Pavimentação</th>
      <th>Comprimento</th>
      <th>Largura</th>
      <th>Profundidade</th>
      <th>Profundidade PL</th>
      <th>Profundidade Rede</th>
      <th>Profundidade PV</th>
      <th>Reaterro</th>
      <th>Observação</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-atividadeServico>
    <tr class="font-grid-servicos">
      <td>{{ atividadeServico.item }}</td>
      <td>{{ atividadeServico.descricaoLocal }}</td>
      <td>{{ atividadeServico.descricaoPavimentacao }}</td>
      <td>{{ atividadeServico.comprimento }}</td>
      <td>{{ atividadeServico.largura }}</td>
      <td>{{ atividadeServico.profundidade }}</td>
      <td>{{ atividadeServico.profundidadePl }}</td>
      <td>{{ atividadeServico.profundidadeRede }}</td>
      <td>{{ atividadeServico.profundidadePv }}</td>
      <td>{{ atividadeServico.reaterro }}</td>
      <td>{{ atividadeServico.observacao }}</td>
    </tr>
  </ng-template>
</p-table>
